/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { useQuery } from "@tanstack/react-query";
import { getServiceLocationDetails } from "./workSiteFunctions";

export function useServiceLocationDetails(siteId: number) {
    return useQuery({
        queryKey: ["OFFICE", "SERVICE_LOCATION", siteId],
        queryFn: () => getServiceLocationDetails(siteId),
        select: ({ data }) => data,
    });
}
